import styled from "styled-components"

const Container = styled.div`
  width: 100%;
  img {
    width: 100%;
    height: auto;
    max-width: 500px;
    @media only screen and (max-width: 876px) {
      width: 100%;
      max-height: 300px;
      object-fit: contain;
      margin-top: 70px;
      padding-inline: 10px;
    }
    @media (max-width: 641px) {
      /* width: 100%; */
      height: 210px;
      margin-top: 0;
      object-fit: cover;
      padding-inline: 0px;
    }
  }
`
interface IProps {
  imageSrc: string
}

const BannerImage: React.FC<IProps> = ({ imageSrc }) => {
  return (
    <Container>
      <img src={imageSrc} />
    </Container>
  )
}

export { BannerImage }
